import { messages } from '@/i18n/messages';
import { createTranslator } from 'next-intl';

export const t = createTranslator({
  locale: 'en',
  messages,
});
